import { render, staticRenderFns } from "./AuditWrapper.vue?vue&type=template&id=23b797cf&scoped=true&"
import script from "./AuditWrapper.vue?vue&type=script&lang=js&"
export * from "./AuditWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AuditWrapper.vue?vue&type=style&index=0&id=23b797cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b797cf",
  null
  
)

export default component.exports